module.exports = __webpack_public_path__ + "static/media/feature_data_visualization.f883ea80.png";